import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const pairs = [{
  problem: 'Cuando estás saturado',
  tool: 'Mindfulness',
  color: 'rose' as const
}, {
  problem: 'Cuando tenés que hablar',
  tool: 'Conversaciones Difíciles',
  color: 'gold' as const
}, {
  problem: 'Cuando no sabés qué decir',
  tool: '100 Respuestas',
  color: 'rose' as const
}, {
  problem: 'Cuando el problema es la dinámica del equipo',
  tool: 'Ejercicios para Mejorar el Ambiente Laboral',
  color: 'gold' as const
}, {
  problem: 'Cuando querés entender qué te pasa bajo presión',
  tool: 'Neurociencia (premium)',
  color: 'rose' as const
}, {
  problem: 'Cuando la jornada terminó y no podés desconectar',
  tool: 'El Umbral del Descanso (premium)',
  color: 'gold' as const
}];
export function ProblemToolMap() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-282" data-mp="1nn0dvfj7tsyk">
      <div className="max-w-5xl mx-auto" data-id="element-283" data-mp="1nns8oo4znmns">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-284" data-mp="2wf2z6389gqel">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-285" data-mp="2ikti322f35vn">
            6 problemas.{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-286" data-mp="3af401ioizxu2">
              6 herramientas.
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-287" data-mp="31dnoh7lz5po9">
          {pairs.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="grid sm:grid-cols-[1fr_auto_1fr] items-center gap-3 sm:gap-5 bg-white border border-line rounded-2xl p-5 md:p-6 shadow-sm" data-id="element-288" data-mp="31fgv4mwl89w9" data-mpi={i}>
              <span className="text-ink font-semibold text-sm md:text-base uppercase tracking-tight" data-id="element-289" data-mp="1me8cnho4j10p">
                {p.problem}
              </span>
              <span className={`hidden sm:flex w-9 h-9 rounded-full items-center justify-center ${p.color === 'rose' ? 'bg-rose/15' : 'bg-gold/15'}`} data-id="element-290" data-mp="1dfvbnrppzfhg">
                <ArrowRightIcon className={`w-4 h-4 ${p.color === 'rose' ? 'text-rose' : 'text-gold'}`} data-id="element-291" data-mp="13pjwta4hzlvs" />
              </span>
              <span className={`font-serif-italic text-lg md:text-xl ${p.color === 'rose' ? 'text-rose' : 'text-gold'}`} data-id="element-292" data-mp="pqkhwu6selct">
                {p.tool}
              </span>
            </motion.div>)}
        </div>

        <p className="text-center font-serif font-bold text-xl md:text-2xl text-ink uppercase tracking-tight mt-10" data-id="element-293" data-mp="64im7gzrxor6">
          Un solo kit para tu día laboral real.
        </p>
      </div>
    </section>;
}